import React from 'react';
import { MotifVerticalNavigation } from '@ey-xd/motif-react';

interface VerticalNavigationProps {
    ariaLabel?: string;
    className?: string;
    collapse?: boolean;
    children?: React.ReactNode;
}
const VerticalNavigation: React.FC<VerticalNavigationProps> = (props: VerticalNavigationProps) => {
    return <MotifVerticalNavigation {...props}>{props.children}</MotifVerticalNavigation>;
};

export default VerticalNavigation;
